module.exports = __webpack_public_path__ + "img/Visa.69d8fd20.svg";